angular.module 'zc.commonApi'

.factory "Image", ($resource, $q, Api) ->
  Image = $resource Api.path("/api/projects/:projectId/images/:imageId"), {
    projectId: @projectId,
    imageId: @id
  }, {
    query:
      method: 'GET'
      isArray: false # Rails returns object instead of array
    destroy:
      method: 'DELETE'
  }

  service =
    all: (params) ->
      d = $q.defer()
      Image.query(params).$promise.then (res) ->
        d.resolve res.images
      , (err) ->
        d.reject err
      d.promise

    get: (params) ->
      d = $q.defer()
      Image.get(params).$promise.then (res) ->
        d.resolve res.images
      , (err) ->
        d.reject err
      d.promise

    markAsUnselectable: (params) ->
      d = $q.defer()
      d.promise
      Image.destroy(projectId: params.project_id, imageId: params.id).$promise.then (res) ->
       d.resolve res.images
      , (err) ->
       d.reject err
      d.promise

  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/image_service.js.coffee